import { DatePicker, Image, message, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { ISalaryReportArchive } from "../../types/salaryArchiveReport.type";
import dayjs from "dayjs";
import { api } from "../../api/api";
import { API } from "../../config/config";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function SalaryArchive() {
  const [reports, setReports] = useState<ISalaryReportArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await api.get("/archive/salary-reports", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });
      setReports(response.data.reports);
      setTotal(response.data.total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение отчетов.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Фото",
      key: "snapshot",
      dataIndex: "snapshot",
      render: (snapshot: string) => (
        <div>
          <Image
            key={snapshot}
            src={`${API}/${snapshot}`}
            width={50}
            height={50}
            preview={{ src: `${API}/${snapshot}` }}
            alt="Фото"
            loading="lazy"
            style={{
              cursor: "pointer",
              borderRadius: 4,
              border: "1px solid #ddd",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
      ),
    },
    {
      title: "Имя",
      dataIndex: "workerName",
      key: "workerName",
    },
    {
      title: "Сумма",
      dataIndex: "totalPrice",
      key: "totalPrice",
    },
    {
      title: "Кол-во Юк",
      dataIndex: "yuk",
      key: "yuk",
    },
    {
      title: "Детали",
      key: "details",
      render: (_: any, record: ISalaryReportArchive) => {
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              maxWidth: "900px",
              margin: 0,
              padding: 0,
            }}
          >
            {record.details.map((detail, index) => (
              <p>
                {index + 1}.{detail.forName} Кол-во{" "}
                {detail.dayQuantity +
                  detail.nightQuantity -
                  detail.wasteQuantity}
              </p>
            ))}
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Архив Отчеты Зарплата</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />
      <Table
        loading={loading}
        columns={columns}
        dataSource={reports}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
